<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Üzenet</li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Üzenet</h1>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Üzenet</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <div v-bind:class="type">{{ text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {}
  },
  computed: {
    type: function() {
      return this.$root.$data.pageMsg.type;
    },
    text: function() {
      return this.$root.$data.pageMsg.text;
    }
  }
}
</script>




// WEBPACK FOOTER //
// message.vue?2a661b0c